import React from 'react';
import { useTheme, alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from 'components/Container';
import SearchField from 'components/SearchField';
import SearchIcon from '@mui/icons-material/Search';
import { useTranslation } from 'react-i18next';

const SearchBoxHero = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      paddingTop={'16vh'}
      minHeight={600}
      height={'auto'}
      position={'relative'}
      sx={{
        backgroundColor: theme.palette.alternate.main,
        background:
          'url(https://storage.googleapis.com/mniahapp-static-dev/ak/background.jpg) no-repeat center',
        backgroundSize: 'cover',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: 1,
          height: 1,
          background: alpha(theme.palette.primary.dark, 0.1),
          zIndex: 1,
        }}
      />
      <Container position={'relative'} zIndex={2}>
        <Box>
          <Box marginBottom={4}>
            <Typography
              variant="h3"
              gutterBottom
              sx={{
                fontWeight: 700,
                color: 'common.white',
              }}
            >
              {t('searchBoxHero.title')}
            </Typography>
            <Typography
              color="text.primary"
              maxWidth={'655px'}
              sx={{
                fontWeight: 400,
                color: 'common.white',
              }}
            >
              {t('searchBoxHero.subtext_1')}
              <br />
              {t('searchBoxHero.subtext_2')}
            </Typography>
          </Box>
          <SearchField
            label={
              (
                <Typography sx={{ display: 'flex', alignItems: 'center' }}>
                  <SearchIcon sx={{ marginRight: '0.5rem' }} />
                  {t('searchBoxHero.searchBoxLabel')}
                </Typography>
              ) as unknown as string
            }
            sx={{
              backgroundColor: theme.palette.alternate.main,
              opacity: 1,
              borderRadius: '10px',
            }}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default SearchBoxHero;
